/** 
 * Base class for any navigation state, provides class name property.
 * When user refreshes an app page, the state parameters turn into plain JSON objects, dropping all the class information.
 * Use className property to retrieve persistent class name.
 */
export abstract class NavigationState {
	abstract readonly className: string;
}
